import $ from "jquery";

function selectedIds() {
  return Array.from(document.querySelectorAll(".artist_check_box"))
    .filter((input) => input.checked)
    .map((input) => input.value);
}

$(() => {
  // Select artists by subheader
  document.querySelectorAll(".select-subheader").forEach((link) => {
    link.addEventListener("click", (evt) => {
      evt.preventDefault();
      document
        .querySelectorAll(`.check_box_${link.dataset.label}`)
        .forEach((input) => (input.checked = true));
    });
  });

  // Select all artists
  document
    .querySelectorAll(".artist-functions button.select-all")
    .forEach((button) =>
      button.addEventListener("click", (evt) => {
        evt.preventDefault();
        document.querySelectorAll(".artist_check_box").forEach((input) => {
          input.checked = true;
        });
      })
    );

  // Forms
  document.querySelectorAll(".artist-functions form").forEach((form) => {
    form.addEventListener("submit", () => {
      form.querySelectorAll(".ids").forEach((input) => {
        input.value = selectedIds().join(",");
      });
    });
  });
});
